import React, { createContext, useContext, useState, ReactNode, SetStateAction } from 'react';

interface SoloContextProps {
    setActionNodeProperties: React.Dispatch<SetStateAction<Record<string, any>>>;
    actionNodeProperties: Record<string, any>
}

const SoloContext = createContext<SoloContextProps | undefined>(undefined);

export const SoloJourneyProvider = ({ children }: { children: ReactNode }) => {
    
    const [actionNodeProperties, setActionNodeProperties] = useState<Record<string, any>>({})

    return (
        <SoloContext.Provider value={{setActionNodeProperties, actionNodeProperties}}>
            {children}
        </SoloContext.Provider>
    );
};

export const useSoloJourneyContext = () => {
    const context = useContext(SoloContext);
    if (!context) throw new Error("useSoloContext error");
    return context;
};
